/**
 * @param {string} symbolId
 * @param {string} [className]
 * @returns {SVGSVGElement}
 */
export function createFlagElement(symbolId, className = 'flag-icon') {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', className);
  svg.setAttribute('width', '20');
  svg.setAttribute('height', '15');
  svg.setAttribute('viewBox', '0 0 640 480');
  svg.setAttribute('aria-hidden', 'true');

  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `#${symbolId}`);

  svg.appendChild(use);
  return svg;
}

export async function loadFlagsSprite() {
  if (document.querySelector('#flags-sprite')) return;

  try {
    const response = await fetch('/assets/images/flags/flags-sprite.svg');
    const svgText = await response.text();

    const spriteContainer = document.createElement('div');
    spriteContainer.id = 'flags-sprite';
    spriteContainer.style.display = 'none';
    spriteContainer.innerHTML = svgText;

    document.body.insertBefore(spriteContainer, document.body.firstChild);
  } catch (error) {
    console.error('[Flags] Failed to load flags sprite:', error);
  }
}

export function ensureFlagsSpriteLoaded() {
  if (!document.querySelector('#flags-sprite')) loadFlagsSprite();
}

/** @param {HTMLElement} navContainer */
export function setupLazyFlagsLoading(navContainer) {
  if (!navContainer) return;

  const isHidden = navContainer.style.transform === 'translateX(-100%)';
  if (isHidden) {
    setupHiddenFlagsLazyLoading(navContainer);
  } else {
    ensureFlagsSpriteLoaded();
  }
}

/** @param {HTMLElement} navContainer */
export function setupHiddenFlagsLazyLoading(navContainer) {
  if (!navContainer) return;

  let visibilityCheckInterval = null;

  const checkVisibility = () => {
    const isVisible =
      navContainer.style.opacity !== '0' &&
      navContainer.style.transform !== 'translateY(-100%)' &&
      getComputedStyle(navContainer).opacity !== '0' &&
      !getComputedStyle(navContainer).transform.includes('translateY(-100%)');

    if (isVisible) {
      ensureFlagsSpriteLoaded();
      if (visibilityCheckInterval) {
        clearInterval(visibilityCheckInterval);
        visibilityCheckInterval = null;
      }
    }
  };

  checkVisibility();
  visibilityCheckInterval = setInterval(checkVisibility, 100);
}
